import { render } from "./Import.vue?vue&type=template&id=50166118&scoped=true"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"

import "./Import.vue?vue&type=style&index=0&id=50166118&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-50166118"

export default script